import React from 'react'
import {useForm, Controller} from 'react-hook-form'
import {observer} from 'mobx-react'
import {useBasketStore, useCustomerStore} from '../../../store/hooks/useStore'
import {Box, Button, Flex, Select, Stack, Text} from '../../../vanilla'
import {OrderAddress} from '../../../types/store/basket'
import { CustomerAddress } from '../../../store/CustomerStore'
import { addressSelectorContainer } from '../styles.css'
interface YourDeliverySavedAddressesProps {
  setDeliveryAddress: (address: OrderAddress) => void
  onAddNewAddressClick: () => void
  delimiter: boolean
}

export const YourDeliverySavedAddresses = observer((props: YourDeliverySavedAddressesProps) => {
  const {setDeliveryAddress, onAddNewAddressClick, delimiter} = props
  const {addresses} = useCustomerStore()
  const {isAppliedPostCodeDeliverable, expandDeliveryAddressForm} = useBasketStore()

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      addressSelection: '',
    },
  })

  const onChangeAddress = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const _addressId = e.target.value
    if (_addressId) {
      const address = addresses?.find(({addressId}) => addressId === _addressId)
      if (address) {
        await setDeliveryAddress(address)
        form.setValue('addressSelection', '')
        expandDeliveryAddressForm(null)
      }
    }
  }

  if (!addresses || !addresses.length) {
    return null
  }

  const renderOption = (address: CustomerAddress) => {
    if(!address){
      return null
    }
    const {addressId, address1, city, postalCode} = address
    return (
      <option key={addressId} value={addressId}>
        {`(${addressId}) ${address1} ${city} ${postalCode}`}
      </option>
    )
  }

  const sortAndRenderOptions = (addresses: Array<CustomerAddress>) => {
    const sortedAddresses = []
    sortedAddresses.push(addresses?.filter(address => address.preferred)[0])
    addresses?.filter(address => !address.preferred).forEach(address => sortedAddresses.push(address))
    return sortedAddresses.map(address => renderOption(address))
  }

  

  return (
    <>
      {delimiter && <Box as="hr" borderColor="gray200" borderBottom="1px" borderTop="0px" />}
      <Stack position="relative" paddingX={'0px'}>
        <Stack spacing="4px">
          <Text as="label" variant="text4" htmlFor="address-selection">
            {isAppliedPostCodeDeliverable
              ? 'Please select your address:'
              : 'Please try a different address:'}
          </Text>
          <Flex direction={['column', 'row']} gap={['8px', '0px', '0px']} >
          <Box className={addressSelectorContainer}>
              <Controller
                name="addressSelection"
                control={form.control}
                rules={{required: false}}
                render={(renderProps) => {
                  const {
                    field: {name},
                    fieldState: {isTouched, invalid},
                  } = renderProps
                  return (
                    <Select
                      validatedSuccessfully={isTouched && !invalid}
                      backgroundColor="gray25"
                      name={name}
                      onChange={onChangeAddress}
                      defaultValue="0"
                      data-cs-mask=""
                    >
                      <option selected disabled value="0">
                        Select from Saved Addresses
                      </option>
                      {addresses && 
                        (addresses?.length === 1 
                          ? renderOption(addresses[0])
                          : sortAndRenderOptions(addresses)
                        )
                      }
                    </Select>
                  )
                }}
              />
            </Box>

          </Flex>
        </Stack>
      </Stack>
    </>
  )
})
